import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { BodyText, FlexRow } from '@make-software/cspr-design';
import { Deploy, GetDeployResult, HashType } from '@block-explorer/entities';
import {
  ContractIdentifier,
  HashFontSize,
  TableDataAccountInfo,
} from '../../../components';
import { deriveSplitDataFromNamedKeyValue } from '../../../domain';
import { DataResponse } from '../../../services';
import { useGetAccountDataFromHash } from '../../../scenes/DeployDetailsScene/utils/use-get-account-data-from-hash';
import { deriveUpdatedAssociatedKey } from '../utils/deploy-action-helpers';

interface DeployAssociatedKeysActionProps {
  deploy: Deploy;
  deployRawData: DataResponse<GetDeployResult> | null;
  renderAsResultAction?: boolean;
}

const DeployActionAssociatedKeys = ({
  deploy,
  deployRawData,
  renderAsResultAction = false,
}: DeployAssociatedKeysActionProps) => {
  const { contractPackage } = deploy;
  const updatedMasterKey = deriveUpdatedAssociatedKey(deployRawData?.data);

  const { hash: hashWithoutPrefix } = deriveSplitDataFromNamedKeyValue(
    updatedMasterKey || ''
  );
  // TODO: DERIVE
  const {
    data: { logo: logo, name: name, publicKey },
    loading: accountInfoLoading,
  } = useGetAccountDataFromHash({
    hash: hashWithoutPrefix,
    type: HashType.accountHash,
  });

  if (accountInfoLoading) {
    return (
      <BodyText size={3}>
        <Skeleton />
      </BodyText>
    );
  }

  const deployActionText = renderAsResultAction
    ? 'Updated account'
    : 'Update account';

  return (
    <FlexRow align={'center'} itemsSpacing={8}>
      <BodyText size={3} monotype variation={'black'}>
        {deployActionText}
      </BodyText>{' '}
      {(publicKey || hashWithoutPrefix) && (
        <TableDataAccountInfo
          logo={logo}
          name={name}
          publicKey={publicKey || hashWithoutPrefix}
          loading={accountInfoLoading}
          avatarSize={'small'}
          hashFontSize={HashFontSize.big}
        />
      )}
      {!renderAsResultAction && (
        <FlexRow itemsSpacing={8} align={'center'}>
          <BodyText size={3} variation={'darkGray'}>
            with
          </BodyText>
          <ContractIdentifier
            hash={contractPackage.contract_package_hash}
            contractPackage={contractPackage}
            hashFontSize={HashFontSize.big}
            avatarSize={'small'}
          />
        </FlexRow>
      )}
    </FlexRow>
  );
};
export default DeployActionAssociatedKeys;
